/* @flow */

import type {McfxCompanyFragment} from 'nutshell-graphql-types';
import type {ListItem} from 'nutshell-core/types';

export const companiesFieldFilterFunction = (fieldName: string) => !['period'].includes(fieldName);

export const getUpdatedMcfxCompanyListItems = (
    listItems: ListItem[],
    updatedCompanies: McfxCompanyFragment[]
): ListItem[] =>
    listItems.map((listItem) => {
        const updatedCompany =
            updatedCompanies && updatedCompanies.find((company) => company.id === listItem.id);

        if (updatedCompany) {
            const newListItem = {
                ...listItem,
                primaryName: updatedCompany.name,
                fields: {
                    ...listItem.fields,
                    name: {value: updatedCompany.name},
                    phone: {
                        value: updatedCompany.phones ? updatedCompany.phones[0] : null,
                    },
                    website: {value: updatedCompany.url},
                    address: {
                        value:
                            updatedCompany.primaryAddress &&
                            updatedCompany.primaryAddress.fullAddress
                                ? updatedCompany.primaryAddress.fullAddress
                                : null,
                    },
                    unlockTime: {value: updatedCompany.unlockTime},
                    convertedTime: {value: updatedCompany.convertedTime},
                },
            };

            return newListItem;
        } else {
            return listItem;
        }
    });
